import { Box, Typography } from '@mui/material';
import { formatRenewalPeriod } from '../renewalFormat';

/** O mínimo do `GET Contracts/{hash}` que o resumo usa — serve à renovação e à troca de cartão. */
export type ContractSummaryData = {
  contract_code?: string | null;
  start_at?: string | null;
  end_at?: string | null;
  insured?: { name?: string | null } | null;
  insured_item?: { model?: string | null; manufacturer?: string | null; serial_number?: string | null } | null;
};

type Props = {
  contract: ContractSummaryData;
  appId: string;
  /** Campos a mais, depois dos padrões (ex.: «Tipo» na troca de cartão). */
  extraFields?: { label: string; value?: string | null }[];
};

function Field({ label, value }: { label: string; value?: string | null }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
      <Typography sx={(theme) => ({ color: theme.customColors.textPlaceholder })} variant="caption">
        {label}
      </Typography>
      <Typography sx={{ color: 'text.primary', fontSize: 12, fontWeight: 500, lineHeight: '16px' }}>
        {value || '—'}
      </Typography>
    </Box>
  );
}

/**
 * Resumo do contrato da renovação (Figma «informacoes-fatura», nodes 2079:6327 e 2086:6919).
 * Reutilizado nas etapas de identificação e de código e no resumo da troca de cartão.
 */
export default function RenewalContractSummary({ contract, appId, extraFields = [] }: Props) {
  const item = contract.insured_item;

  return (
    <Box
      data-app-id={appId}
      data-testid="renewal-contract-summary"
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        p: '16px',
        width: '100%'
      }}
    >
      <Typography sx={{ color: 'text.primary', fontSize: 14, fontWeight: 700, lineHeight: '24px' }}>
        {contract.insured?.name}
      </Typography>
      <Box
        sx={{ columnGap: '12px', display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', rowGap: '12px' }}
      >
        {/* Rótulo padronizado em «Nº Certificado» (o Figma 2079:6265 traz «Nº do contrato»; decisão em CORE-988). */}
        <Field label="Nº Certificado" value={contract.contract_code} />
        <Field label="Vigência" value={formatRenewalPeriod(contract.start_at ?? '', contract.end_at ?? '')} />
        <Field label="Modelo" value={item?.model} />
        <Field label="Marca" value={item?.manufacturer} />
        <Field label="Chassi do equipamento" value={item?.serial_number} />
        {extraFields.map((f) => (
          <Field key={f.label} label={f.label} value={f.value} />
        ))}
      </Box>
    </Box>
  );
}
